import CourseGradePage from './CourseGradePage';

export default CourseGradePage;
